import { useContext, useEffect, useState } from "react";
import Configurationcontext from "../../Context/ConfigrationContext/Configurationcontext";
import configurationConstants from "../../apis/configuration/configurationConstants";
import ConfirmationModal from "./ConfirmationModal";
import "./ChartFieldConfiguration.css";
import AddChartInfoFieldModal from "./AddChartInfoFieldModal";
import configurationAPI from "../../apis/configuration/configurationAPI";
import EditChartInfoFieldModal from "./EditChartInfoFieldModal";
import Swal from "sweetalert2";

const ChartFieldConfiguration = ({
  location,
  clientCurrentId,
  selectedLoc,
  fetchConfigurationData,
}) => {
  const data = useContext(Configurationcontext);
  const configurationProvider = useContext(Configurationcontext);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [deleteParams, setDeleteParams] = useState({});
  const [selectedSpecialty, setSelectedSpecialty] = useState(0);
  const [configuredFields, setConfiguredFields] = useState({});
  const [showAddChartInfoFieldModal, setShowAddChartInfoFieldModal] = useState(false);
  const [chartInfoCustomFields, setChartInfoCustomFields] = useState([]);
  const [showEditChartInfoFieldModal, setShowEditChartInfoFieldModal] = useState(false);
  const [chartInfoEditData, setChartInfoEditData] = useState({});
  const [invalidateChartInfoFields, setInvalidateChartInfoFields] = useState(false);
  const [isDeleting, setIsDeleting] = useState(null);

  const handleOpenAddChartInfoFieldModal = () => {
    if(chartInfoCustomFields?.length >= 5){
      window.toastr.error("You can't add more than 5 custom fields.");
      return;
    }
    setShowAddChartInfoFieldModal(true)
  };
  const handleCloseAddChartInfoFieldModal = () => setShowAddChartInfoFieldModal(false);
  const handleOpenEditChartInfoFieldModal = () => setShowEditChartInfoFieldModal(true);
  const handleCloseEditChartInfoFieldModal = () => setShowEditChartInfoFieldModal(false);

  const fetchChartInfoCustomFields = async() => {
    try {
      const res = await configurationAPI.getChartInfoCustomFields(clientCurrentId, selectedLoc);
      if (res.success) {
        setChartInfoCustomFields(res?.data);
      } else {
        window.toastr.error(res?.message)
      }
    } catch (error) {
      window.toastr.error(error?.message || "Couldn't fetch chart info custom fields.");
   }
  };

  useEffect(() => {
    let flag = true;
    if (flag && selectedLoc && clientCurrentId) {
      fetchChartInfoCustomFields()
    }
    return () => flag = false;

    // eslint-disable-next-line
  }, [clientCurrentId, selectedLoc, invalidateChartInfoFields]);

  const handleShowChartInfoCustomFieldsEditModal = (data) => {
    setChartInfoEditData(data);
    handleOpenEditChartInfoFieldModal();
  }
  
  const handleFieldValidationConfig = (event) => {
    const radioGroup = event.target.name;
    //const radioValue = event.target.value;
    const radioIndex = Array.from(document.querySelectorAll(`input[name="${radioGroup}"]`)).indexOf(event.target);
    
    let updatedConfig = { ...configurationProvider.fieldValidationConfig };
    if (radioIndex === 0) {
      updatedConfig[radioGroup] = "M";
    } else if (radioIndex === 1) {
      updatedConfig[radioGroup] = "NM";
    } else if (radioIndex === 2) {
      updatedConfig[radioGroup] = "NA";
    }
    configurationProvider.setSubmitData(prevSubmitData => ({
      ...prevSubmitData,
      [configurationConstants.CHART_FIELD_CONFIGURATION]: {
        ...prevSubmitData[configurationConstants.CHART_FIELD_CONFIGURATION],
        [radioGroup]: updatedConfig[radioGroup]
      },
      SpecialtyId: selectedSpecialty
    }));
  };

  const clearRadioSelections = () => {
    document.querySelectorAll(`.chart-configurable-fields input[type="radio"]`).forEach((el) => (el.checked = false))
  }

  // useEffect(() => { console.log("SubmitData", configurationProvider.submitData) }, [configurationProvider.submitData])

  useEffect(() => {
    if (configuredFields[selectedSpecialty]) {
      // Remove previous radio button selections
      clearRadioSelections();

      // Set radio button selections based on configured fields
      Object.keys(configuredFields[selectedSpecialty]).map((validation) => {
        switch(configuredFields[selectedSpecialty][validation]) {
          case "M":
            let inputM = document.querySelector(`td:nth-child(2) input[name="${validation}"]`);
            if(inputM)
              inputM.checked = true;
            break;
          case "NM":
            let inputNM = document.querySelector(`td:nth-child(3) input[name="${validation}"]`);
            if(inputNM)
              inputNM.checked = true;
            break;
          case "NA":
            let inputNA = document.querySelector(`td:nth-child(4) input[name="${validation}"]`);
            if(inputNA)
              inputNA.checked = true;
            break;
          default:
            document.querySelector(`td:nth-child(2) input[name="${validation}"]`).checked = false;
            document.querySelector(`td:nth-child(3) input[name="${validation}"]`).checked = false;
            document.querySelector(`td:nth-child(4) input[name="${validation}"]`).checked = false;
            break;
        }
        return validation;
      });
      configurationProvider.setSubmitData({
        ...configurationProvider.submitData,
        [configurationConstants.CHART_FIELD_CONFIGURATION]: configuredFields[selectedSpecialty]??{},
        SpecialtyId: selectedSpecialty
      })
    } else {
      clearRadioSelections();

      if(location.length) {
        window.toastr.info('No Chart Field Configuration set for selected Client/Location/Specialty.');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configuredFields, selectedSpecialty])

  useEffect(() => {
    // Sort specialty wise field configuration
    if(Object.keys(data?.fieldValidationConfig)?.length > 0) {
      let specialtyWiseFieldConfig = {};

      data?.fieldValidationConfig?.map((item) => { 
        specialtyWiseFieldConfig[item.SpecialtyId] = {...specialtyWiseFieldConfig[item.SpecialtyId], [item.field]: item.validation};
        return item;
      });
      
      setConfiguredFields(specialtyWiseFieldConfig);
    } else {
      clearRadioSelections();
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.fieldValidationConfig])
  
  useEffect(() => {
    // Add event listener to radio buttons
    const radioButtons = document.querySelectorAll('input[type="radio"]');
    radioButtons.forEach((radioButton) => {
      radioButton.addEventListener("change", handleFieldValidationConfig);
    });

    configurationProvider.setConfigurableFieldsCount(document.querySelectorAll('.chart-configurable-fields td:nth-child(2) input[type="radio"]').length);

    return () => {
      radioButtons.forEach((radioButton) => {
        radioButton.removeEventListener("change", handleFieldValidationConfig);
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSpecialty]);

  const handleDeleteChartInfoCustomField = (id) => {
    if (!id) return;
    Swal.fire({
      text: `Do you want to delete selected item?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn btn-sm btn-primary',
        cancelButton: 'btn btn-sm btn-secondary',
      },
    }).then(async (result) => {
      if (result?.value === true) {
        setIsDeleting(id);
        try {
          const res = await configurationAPI.deleteChartInfoCustomField(id);
          if (res.success) {
            window.toastr.success(res?.message);
            setInvalidateChartInfoFields(prev => !prev);
          } else {
            window.toastr.error(res?.message);
          }
        }
        catch (error) {
          window.toastr.error(error?.message);
        }
      }
    });
    setIsDeleting(null);
  }
  
  return (
    <>
      <div className="d-flex flex-column gap-7 gap-lg-5">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="card card-flush mb-4">
              <div className="card-header">
                <div className="card-title d-flex gap-4">
                  <h4>Chart Info Fields' Configuration</h4>
                  {(clientCurrentId && selectedLoc) ? <button
                    onClick={handleOpenAddChartInfoFieldModal}
                    type="button"
                    aria-label="Add Field"
                    className="btn btn-primary btn-sm"
                    // disabled={chartInfoCustomFields.length >= 5}
                  > <i className="fas fa-plus" /> Add Field
                  </button> : null}
                </div>
              </div>
              <div className="card-body pt-0">
                <div className="col-3 mb-5">
                  <label className="form-label">Primary Speciality </label>
                  <select
                    className="form-select mb-2"
                    data-hide-search="true"
                    name="SpecialtyId"
                    onChange={(event) => {setSelectedSpecialty(event.target.value)}}
                  >
                    <option value="0">All</option>
                    {configurationProvider?.configrationSpecialities?.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.spec_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="row justify-content-around align-items-start">
                  <table className="chart-configurable-fields col-5" cellSpacing={8} cellPadding={8}>
                    <thead>
                      <tr>
                        <th></th>
                        <th><button className="btn btn-primary btn-sm" onClick={() => { document.querySelectorAll('td:nth-child(2) input[type=radio]').forEach((el) => { el.checked = true; el.dispatchEvent(new Event('change', { bubbles: true })) }) }}>Select All</button></th>
                        <th><button className="btn btn-primary btn-sm" onClick={() => { document.querySelectorAll('td:nth-child(3) input[type=radio]').forEach((el) => { el.checked = true; el.dispatchEvent(new Event('change', { bubbles: true })) }) }}>Select All</button></th>
                        <th></th>
                      </tr>
                    </thead>
                    <thead>
                      <tr>
                        <th>Fields</th>
                        <th>Mandatory</th>
                        <th>Non-Mandatory</th>
                        <th>Not-Applicable</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Chart No.</td>
                        <td> <label><input type="radio" name="chart_no" /></label> </td>
                        <td> <label><input type="radio" name="chart_no" /></label> </td>
                        <td> <label><input type="radio" name="chart_no" /></label> </td>
                      </tr>
                      <tr>
                        <td>MR Number</td>
                        <td> <label><input type="radio" name="mr_no" /></label> </td>
                        <td> <label><input type="radio" name="mr_no" /></label> </td>
                        <td> <label><input type="radio" name="mr_no" /></label> </td>
                      </tr>
                      <tr>
                        <td>DOS</td>
                        <td> <label><input type="radio" name="date_of_service" /></label> </td>
                        <td> <label><input type="radio" name="date_of_service" /></label> </td>
                        <td> <label><input type="radio" name="date_of_service" /></label> </td>
                      </tr>
                      <tr>
                        <td>Admit Date</td>
                        <td> <label><input type="radio" name="admit_date" /></label> </td>
                        <td> <label><input type="radio" name="admit_date" /></label> </td>
                        <td> <label><input type="radio" name="admit_date" /></label> </td>
                      </tr>
                      <tr>
                        <td>Discharge Date</td>
                        <td> <label><input type="radio" name="discharge_date" /></label> </td>
                        <td> <label><input type="radio" name="discharge_date" /></label> </td>
                        <td> <label><input type="radio" name="discharge_date" /></label> </td>
                      </tr>
                      <tr>
                        <td>Disposition</td>
                        <td> <label><input type="radio" name="disposition" /></label> </td>
                        <td> <label><input type="radio" name="disposition" /></label> </td>
                        <td> <label><input type="radio" name="disposition" /></label> </td>
                      </tr>
                      <tr>
                        <td>EM</td>
                        <td> <label><input type="radio" name="em" /></label> </td>
                        <td> <label><input type="radio" name="em" /></label> </td>
                        <td> <label><input type="radio" name="em" /></label> </td>
                      </tr>
                      <tr>
                        <td>Primary Diagnosis</td>
                        <td> <label><input type="radio" name="primary_diagnosis" /></label> </td>
                        <td> <label><input type="radio" name="primary_diagnosis" /></label> </td>
                        <td> <label><input type="radio" name="primary_diagnosis" /></label> </td>
                      </tr>
                      <tr>
                        <td>Primary Health Plan</td>
                        <td> <label><input type="radio" name="primary_health" /></label> </td>
                        <td> <label><input type="radio" name="primary_health" /></label> </td>
                        <td> <label><input type="radio" name="primary_health" /></label> </td>
                      </tr>
                      {/* <tr>
                      <td>Primary Speciality</td>
                      <td> <label><input type="radio" name="primary_speciality" /></label> </td>
                      <td> <label><input type="radio" name="primary_speciality" /></label> </td>
                      <td> <label><input type="radio" name="primary_speciality" /></label> </td>
                    </tr> */}
                      <tr>
                        <td>Facility</td>
                        <td> <label><input type="radio" name="facility" /></label> </td>
                        <td> <label><input type="radio" name="facility" /></label> </td>
                        <td> <label><input type="radio" name="facility" /></label> </td>
                      </tr>
                      <tr>
                        <td>POA</td>
                        <td> <label><input type="radio" name="poa" /></label> </td>
                        <td> <label><input type="radio" name="poa" /></label> </td>
                        <td> <label><input type="radio" name="poa" /></label> </td>
                      </tr>
                      <tr>
                        <td>LOS</td>
                        <td> <label><input type="radio" name="los" /></label> </td>
                        <td> <label><input type="radio" name="los" /></label> </td>
                        <td> <label><input type="radio" name="los" /></label> </td>
                      </tr>
                      <tr>
                        <td>DRG Value</td>
                        <td> <label><input type="radio" name="drg" /></label> </td>
                        <td> <label><input type="radio" name="drg" /></label> </td>
                        <td> <label><input type="radio" name="drg" /></label> </td>
                      </tr>
                      <tr>
                        <td>Procedure Code</td>
                        <td> <label><input type="radio" name="procedure_code" /></label> </td>
                        <td> <label><input type="radio" name="procedure_code" /></label> </td>
                        <td> <label><input type="radio" name="procedure_code" /></label> </td>
                      </tr>
                      <tr>
                        <td>Sub Speciality</td>
                        <td> <label><input type="radio" name="sub_specialty" /></label> </td>
                        <td> <label><input type="radio" name="sub_specialty" /></label> </td>
                        <td> <label><input type="radio" name="sub_specialty" /></label> </td>
                      </tr>
                      <tr>
                        <td>Chart Status</td>
                        <td> <label><input type="radio" name="chart_status" /></label> </td>
                        <td> <label><input type="radio" name="chart_status" /></label> </td>
                        <td> <label><input type="radio" name="chart_status" /></label> </td>
                      </tr>
                      <tr>
                        <td>Responsible Party</td>
                        <td> <label><input type="radio" name="responsible_parties" /></label> </td>
                        <td> <label><input type="radio" name="responsible_parties" /></label> </td>
                        <td> <label><input type="radio" name="responsible_parties" /></label> </td>
                      </tr>
                      <tr>
                        <td>Coder Comments to Client</td>
                        <td> <label><input type="radio" name="coder_comments" /></label> </td>
                        <td> <label><input type="radio" name="coder_comments" /></label> </td>
                        <td> <label><input type="radio" name="coder_comments" /></label> </td>
                      </tr>
                      <tr>
                        <td>Rejection/Denial Comments</td>
                        <td> <label><input type="radio" name="rejection_comments" /></label> </td>
                        <td> <label><input type="radio" name="rejection_comments" /></label> </td>
                        <td> <label><input type="radio" name="rejection_comments" /></label> </td>
                      </tr>
                      <tr>
                        <td>Deficiency Comments</td>
                        <td> <label><input type="radio" name="deficiency_comments" /></label> </td>
                        <td> <label><input type="radio" name="deficiency_comments" /></label> </td>
                        <td> <label><input type="radio" name="deficiency_comments" /></label> </td>
                      </tr>
                    </tbody>
                  </table>

                  <table className="col-6" cellSpacing={8} cellPadding={8}>
                    <thead>
                    <tr>
                        <th>Custom Fields</th>
                        <th>Type</th>
                        <th>Is Multi-select</th>
                        <th>Validation </th>
                        <th>Placement </th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        chartInfoCustomFields?.map((customField) => (
                          <tr key={customField.id}>
                            <td>{customField?.name}</td>
                            <td>{customField?.type}</td>
                            <td>{customField?.type !== 'dropdown' ? 'NA' : customField?.isMultiSelect ? 'Yes' : 'No'}</td>
                            <td>{customField?.validation}</td>
                            <td>{customField?.placement}</td>
                            <td>
                              <div className="d-flex gap-2 justify-content-center align-items-center">
                                <button onClick={() => handleShowChartInfoCustomFieldsEditModal(customField)} className="btn btn-sm"><i className="fa fa-edit" /></button>
                                <button onClick={() => handleDeleteChartInfoCustomField(customField.id)} className="btn btn-sm"><i className="fa fa-trash" /></button>
                                {isDeleting === customField.id && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />}
                              </div>
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                  
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          deleteParams={deleteParams}
          setDeleteParams={setDeleteParams}
          showConfirmationModal={showConfirmationModal}
          setShowConfirmationModal={setShowConfirmationModal}
          fetchConfigurationData={fetchConfigurationData}
        />
      )}
      {
        ((clientCurrentId !== undefined && selectedLoc !== undefined) && showAddChartInfoFieldModal) && (
          <AddChartInfoFieldModal
            onHide={handleCloseAddChartInfoFieldModal}
            show={showAddChartInfoFieldModal}
            selectedLoc={selectedLoc}
            selectedClient={clientCurrentId}
            setInvalidateChartInfoFields={setInvalidateChartInfoFields}
          />
        )
      }
      {
        ((clientCurrentId !== undefined && selectedLoc !== undefined) && showEditChartInfoFieldModal) && (
          <EditChartInfoFieldModal
            onHide={handleCloseEditChartInfoFieldModal}
            show={showEditChartInfoFieldModal}
            chartInfoEditData={chartInfoEditData}
            selectedLoc={selectedLoc}
            selectedClient={clientCurrentId}
            setInvalidateChartInfoFields={setInvalidateChartInfoFields}
          />
        )
      }
    </>
  );
};
export default ChartFieldConfiguration;
